import Link from 'next/link';

import { Typography } from 'lighthouse';

import { CategoryMegaMenuParentsProps } from './models';

import { Element4 } from 'iconsax-react';

export const CategoryMegaMenuParents = ({ categories, activeCategoryId, isDark, onHoverCategory, onNavigate }: CategoryMegaMenuParentsProps) => (
    <aside
        className={`flex h-full w-[280px] shrink-0 flex-col border-l ${isDark ? 'border-neutral-700 bg-[#0b1220]' : 'border-gray-200 bg-[#f9fafb]'}`}>
        <div className={`flex shrink-0 items-center gap-2.5 border-b px-4 py-4 ${isDark ? 'border-neutral-700' : 'border-gray-200'}`}>
            <span className={`flex h-8 w-8 items-center justify-center rounded-lg ${isDark ? 'bg-white/10' : 'bg-white'}`}>
                <Element4 size={17} color='currentColor' className='text-primary' variant='Bulk' />
            </span>
            <Typography variant='caption' className={`text-xs font-bold ${isDark ? 'text-white' : 'text-[#101828]'}`}>
                خدمات
            </Typography>
        </div>

        <ul
            className={`nice-scroll m-0 min-h-0 flex-1 list-none overflow-y-auto p-0
                ${isDark ? 'divide-y divide-neutral-700' : 'divide-y divide-gray-200'}`}>
            {categories.map((category) => {
                const isActive = category.id === activeCategoryId;

                return (
                    <li key={category.id}>
                        <Link
                            href={category.href}
                            onMouseEnter={() => onHoverCategory(category.id)}
                            onFocus={() => onHoverCategory(category.id)}
                            onClick={onNavigate}
                            className={`font-inherit relative box-border flex w-full cursor-pointer items-center border-0 px-4 py-3.5 text-right
                            no-underline outline-none transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-primary/30 ${
                                isActive
                                    ? isDark
                                        ? 'bg-white/10 text-white'
                                        : 'bg-white text-primary'
                                    : isDark
                                      ? 'bg-transparent text-neutral-300 hover:bg-white/5 hover:text-white'
                                      : 'bg-transparent text-[#344054] hover:bg-white/70 hover:text-[#101828]'
                            }`}>
                            <span
                                className={`absolute inset-y-0 right-0 w-0.5 ${isActive ? (isDark ? 'bg-white' : 'bg-primary') : 'bg-transparent'}`}
                            />
                            <Typography
                                variant='body2'
                                component='span'
                                className={`block w-full truncate text-[13px] leading-5 ${isActive ? 'font-bold' : 'font-medium'}`}>
                                {category.name}
                            </Typography>
                        </Link>
                    </li>
                );
            })}
        </ul>
    </aside>
);
